module.exports = __webpack_public_path__ + "static/img/全球司库管理云7.b91221e8.png";